import { render } from "./Collection.vue?vue&type=template&id=9a69db02&scoped=true"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"

import "./Collection.vue?vue&type=style&index=0&id=9a69db02&scoped=true&lang=less&rel=stylesheet%2Fless"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a69db02"]])

export default __exports__